import { Controller } from '@hotwired/stimulus';

import { driver } from 'driver.js';

export default class extends Controller {
  static targets = [
    'systemDropdown',
    'step1',
    'step2',
    'step3',
    'step4',
    'step5',
    'step6',
    'step7',
    'step8',
    'step9',
    'step10',
    'step11',
    'step12',
  ];

  static values = {
    skip: String,
    back: String,
    next: String,
    finish: String,
    nextTour: String,
    title: String,
  };

  start() {
    this.driverObj = driver({
      showProgress: true,
      nextBtnText: this.nextValue,
      prevBtnText: this.backValue,
      doneBtnText: this.finishValue,

      overlayColor: '#555',
      popoverClass: 'driverjs-theme',

      onNextClick: (element, step, { config, state }) => {
        if (state.activeIndex == config.steps.length - 1) {
          this.driverObj.moveNext();

          // Start next tour
          const tourSelfElement =
            this.application.getControllerForElementAndIdentifier(
              this.element,
              'tour-self-element',
            );
          tourSelfElement.start();
        } else this.driverObj.moveNext();
      },

      onPopoverRender: (popover, { config, state }) => {
        if (state.activeIndex == config.steps.length - 1) {
          // Change text of next button to "Next tour"
          const nextButton = document.getElementsByClassName(
            'driver-popover-next-btn',
          )[0];

          nextButton.innerText = this.nextTourValue;
        }
      },

      steps: [
        {
          element: this.step1Target,
          popover: {
            title: this.titleValue,
            description: this.step1Target.dataset.tourNatalChartStep1Text,

            onNextClick: () => {
              this.showSystemDropdown();
              this.systemCheckboxAll.checked = false;
              this.systemCheckboxAll.dispatchEvent(new Event('input'));
              this.systemCheckboxBazi.checked = true;
              this.systemCheckboxBazi.dispatchEvent(new Event('input'));

              this.driverObj.moveNext();
            },
          },
        },

        {
          element: this.step2Target,
          popover: {
            title: this.titleValue,
            description: this.step2Target.dataset.tourNatalChartStep2Text,

            onNextClick: () => {
              this.hideSystemDropdown();
              this.driverObj.moveNext();
            },

            onPrevClick: () => {
              this.hideSystemDropdown();
              this.driverObj.movePrevious();
            },
          },
        },

        {
          element: this.step3Target,
          popover: {
            title: this.titleValue,
            description: this.step3Target.dataset.tourNatalChartStep3Text,
            side: 'right',

            onPrevClick: () => {
              this.showSystemDropdown();
              this.driverObj.movePrevious();
            },
          },
        },

        {
          element: this.step4Target,
          popover: {
            title: this.titleValue,
            description: this.step4Target.dataset.tourNatalChartStep4Text,
            side: 'right',
          },
        },

        {
          element: this.step5Target,
          popover: {
            title: this.titleValue,
            description: this.step5Target.dataset.tourNatalChartStep5Text,
            side: 'right',
          },
        },

        {
          element: this.step6Target,
          popover: {
            title: this.titleValue,
            description: this.step6Target.dataset.tourNatalChartStep6Text,
            side: 'right',
          },
        },

        {
          element: this.step7Target,
          popover: {
            title: this.titleValue,
            description: this.step7Target.dataset.tourNatalChartStep7Text,
            side: 'right',
          },
        },

        {
          element: this.step8Target,
          popover: {
            title: this.titleValue,
            description: this.step8Target.dataset.tourNatalChartStep8Text,
            side: 'right',
          },
        },

        {
          element: this.step9Target,
          popover: {
            title: this.titleValue,
            description: this.step9Target.dataset.tourNatalChartStep9Text,
            side: 'right',
          },
        },

        {
          element: this.step10Target,
          popover: {
            title: this.titleValue,
            description: this.step10Target.dataset.tourNatalChartStep10Text,
            side: 'right',

            onNextClick: () => {
              this.showSystemDropdown();
              this.systemCheckboxElements.checked = true;
              this.systemCheckboxElements.dispatchEvent(new Event('input'));
              this.systemCheckboxHiddenStems.checked = false;
              this.systemCheckboxHiddenStems.dispatchEvent(new Event('input'));

              this.driverObj.moveNext();
            },
          },
        },

        {
          element: this.step11Target,
          popover: {
            title: this.titleValue,
            description: this.step11Target.dataset.tourNatalChartStep11Text,
            side: 'right',

            onNextClick: () => {
              this.hideSystemDropdown();
              this.driverObj.moveNext();
            },

            onPrevClick: () => {
              this.systemCheckboxElements.checked = false;
              this.systemCheckboxElements.dispatchEvent(new Event('input'));

              this.hideSystemDropdown();
              this.driverObj.movePrevious();
            },
          },
        },

        {
          element: null,
          popover: {
            title: this.titleValue,
            description: this.step12Target.dataset.tourNatalChartStep12Text,

            onPrevClick: () => {
              this.showSystemDropdown();
              this.driverObj.movePrevious();
            },
          },
        },
      ],
    });

    this.driverObj.drive();
  }

  disconnect() {
    this.driverObj?.destroy();
  }

  showSystemDropdown() {
    this.systemDropdownController.show();
  }

  hideSystemDropdown() {
    this.systemDropdownController.hide(new Event('click'));
  }

  get systemDropdownController() {
    return this.application.getControllerForElementAndIdentifier(
      this.systemDropdownTarget,
      'dropdown',
    );
  }

  get systemCheckboxAll() {
    return document.querySelector("[data-filter='all']");
  }

  get systemCheckboxElements() {
    return document.querySelector("[data-filter='elements']");
  }

  get systemCheckboxHiddenStems() {
    return document.querySelector("[data-filter='hidden_stems']");
  }

  get systemCheckboxBazi() {
    return document.querySelector("[data-filter='bazi']");
  }
}
